import type {ReactElement} from 'react';
import '@Global/modal';
import App from '@Components/app';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {ModalContainer} from '@Components/modal-container';
import {LoadingToast} from '@Components/loading-toast';
import type {OrganiserDetails} from '@Components/event-wizard/event-wizard-organisers/event-wizard-organisers.types';
import type {EventType} from '@Components/event-wizard/type-dropdown/type-dropdown.types';
import type {PlaceDetails} from '@Components/google-map/google-map.types';
import type {EventVO, EventVOMinifiedWizardPrefill} from '@Components/events/events.types';
import type {EventWizardSourceType} from '@Components/event-wizard/event-wizard.types';
import type {EventStyles} from '@Components/event-wizard/event-style/event-style.types';
import {MESSAGE_GROWL_KEY} from '@Components/event-wizard/event-wizard.types';
import {LOADING_TOAST_KEY} from '@Components/event-wizard/event-wizard.types';
import {EventWizard} from '@/components/event-wizard';
import {MessageGrowl} from '@Components/message-growl';
import {useLoadI18} from '@Hooks/useLoadI18';
import {renderApp} from '@Utils/renderApp.util';

interface ReactPageProps {
  googleMapAPIKey: string;
  organisers: OrganiserDetails[];
  types: EventType[];
  teamName: string | null;
  teamSize: number | null;
  customRegisterBtnTexts: string[];
  userPastVenues: PlaceDetails[];
  eventWizardSourceType: EventWizardSourceType;
  eventVO?: EventVO;
  eventVOMinifiedWizardPrefill?: EventVOMinifiedWizardPrefill;
  latestEventStyle: EventStyles | null;
  doesPAYGUserHaveAITemplateLimit: boolean;
  shouldUpsellRecurring: boolean;
  shouldShowRecurringEventDetails: boolean;
  isTicketingCountrySupported: boolean;
  isPaidTicketingFeatureAvailable: boolean;
  notifyMeEmail: string;
}

const reactPageProps = window.reactPageProps as ReactPageProps;

function EventWizardApp(): ReactElement<any> | null {
  const i18Loaded = useLoadI18();

  if (!i18Loaded) {
    return <App />;
  }

  return (
    <App>
      <ModalContainerDeprecated />
      <ModalContainer />
      <MessageGrowl key={MESSAGE_GROWL_KEY} />
      <LoadingToast key={LOADING_TOAST_KEY} />
      <EventWizard {...reactPageProps} />
    </App>
  );
}

renderApp(<EventWizardApp />);
